import { z } from "zod";

export const ExchangeRateQuerySchema = z.object({
  from: z
    .string()
    .trim()
    .min(3)
    .max(8)
    .transform((value) => value.toUpperCase()),
  to: z
    .string()
    .trim()
    .min(3)
    .max(8)
    .transform((value) => value.toUpperCase()),
});

export const ExchangeRateQuoteSchema = z.object({
  fromCurrency: z.string(),
  targetCurrency: z.string(),
  rate: z.string(),
  rateTime: z.string().datetime(),
  provider: z.string(),
});

export const WorkdayQuerySchema = z.object({
  year: z.coerce.number().int().min(2000).max(2100),
});
export const WorkdayResponseSchema = z.object({
  year: z.number().int(),
  holidays: z.array(
    z.object({
      date: z.string().date(),
      type: z.enum(["holiday", "workday_adjustment"]),
      name: z.string(),
    }),
  ),
});

export type ExchangeRateQuote = z.infer<typeof ExchangeRateQuoteSchema>;
export type WorkdayResponse = z.infer<typeof WorkdayResponseSchema>;
